/**
 * Synergies d’équipe — constantes et calcul chaînes évolutives (client).
 */

/** +20 % DPS si toute l’équipe partage au moins un type. */
export const TEAM_SYNERGY_MONOTYPE_DPS_MULT = 1.2

/** +10 % or si toute l’équipe est de la même génération. */
export const TEAM_SYNERGY_FULL_GEN_GOLD_MULT = 1.1

/** +8 % DPS par chaîne complète, plafond 2 chaînes (+16 % max). */
export const TEAM_SYNERGY_EVO_CHAIN_DPS_PER_CHAIN = 0.08
export const TEAM_SYNERGY_EVO_CHAIN_MAX_CHAINS = 2

/** +25 % DPS si duo légendaire canonique présent. */
export const TEAM_SYNERGY_LEGEND_DUO_DPS_MULT = 1.25

/** +10 % taux shiny si 4+ chromatiques en équipe. */
export const TEAM_SYNERGY_SHINY_MAJORITY_MULT = 1.1
export const TEAM_SYNERGY_SHINY_MAJORITY_MIN = 4

export function getEvoChainDpsMult(chainsCount: number): number {
  const count = Math.max(0, Math.floor(Number(chainsCount) || 0))
  if (count <= 0) return 1
  const capped = Math.min(count, TEAM_SYNERGY_EVO_CHAIN_MAX_CHAINS)
  return 1 + capped * TEAM_SYNERGY_EVO_CHAIN_DPS_PER_CHAIN
}

type EvoEdge = { fromSlug: string; toSlug: string }

function buildEvoChildrenMap(
  evolutions: ReadonlyArray<EvoEdge>,
): Map<string, string[]> {
  const children = new Map<string, string[]>()
  for (const evo of evolutions) {
    const list = children.get(evo.fromSlug)
    if (list) list.push(evo.toSlug)
    else children.set(evo.fromSlug, [evo.toSlug])
  }
  return children
}

export function countCompleteEvolutionChains(
  slugs: readonly string[],
  evolutions: ReadonlyArray<EvoEdge>,
): number {
  const slugSet = new Set(slugs)
  let chainsCount = 0
  const usedSlugs = new Set<string>()
  const childrenByFrom = buildEvoChildrenMap(evolutions)

  for (const evo1 of evolutions) {
    const thirdStages = childrenByFrom.get(evo1.toSlug) ?? []
    for (const third of thirdStages) {
      if (
        slugSet.has(evo1.fromSlug) &&
        slugSet.has(evo1.toSlug) &&
        slugSet.has(third) &&
        !usedSlugs.has(evo1.fromSlug)
      ) {
        chainsCount++
        usedSlugs.add(evo1.fromSlug)
        usedSlugs.add(evo1.toSlug)
        usedSlugs.add(third)
      }
    }
  }

  for (const evo of evolutions) {
    if (
      slugSet.has(evo.fromSlug) &&
      slugSet.has(evo.toSlug) &&
      !usedSlugs.has(evo.fromSlug) &&
      !usedSlugs.has(evo.toSlug)
    ) {
      chainsCount++
      usedSlugs.add(evo.fromSlug)
      usedSlugs.add(evo.toSlug)
    }
  }

  return chainsCount
}

export function formatEvoChainDpsBonusPercent(chainsCount: number): number {
  return Math.round((getEvoChainDpsMult(chainsCount) - 1) * 100)
}
